// Language Guide (proto 3) | Protocol Buffers Documentation https://protobuf.dev/programming-guides/proto3/

// @generated by protoc-gen-es v1.3.0 with parameter "target=js+dts"
// @generated from file v1/main.proto (package v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { ErrorCode } from "./error_pb.js";

/**
 * @generated from message v1.Error
 */
export const Error = proto3.makeMessageType(
  "v1.Error",
  () => [
    { no: 1, name: "code", kind: "enum", T: proto3.getEnumType(ErrorCode) },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.User
 */
export const User = proto3.makeMessageType(
  "v1.User",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "opt_password", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "opt_code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "opt_code_expires_at_rfc3339", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "opt_role", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "opt_one_time_password", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "opt_course", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "opt_status", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "opt_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "opt_family_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "opt_name_pronunciation", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "opt_family_name_pronunciation", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 13, name: "opt_birthday", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 14, name: "opt_parent_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 15, name: "opt_parent_name_pronunciation", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 16, name: "opt_postal_number", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 17, name: "opt_address1", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 18, name: "opt_address2", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 19, name: "opt_phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 20, name: "opt_cell_number", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 21, name: "opt_email", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 22, name: "opt_note", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 23, name: "opt_expires_at_rfc3339", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 24, name: "opt_expires", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 25, name: "opt_manager_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 26, name: "opt_manager_division", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 27, name: "opt_manager_phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 28, name: "opt_vendor_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 29, name: "opt_comment", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 30, name: "opt_schoolroom_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 31, name: "opt_last_login_at_rfc3339", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 32, name: "vendor_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 33, name: "schoolroom_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 34, name: "opt_image_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 35, name: "opt_result", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 36, name: "opt_login_path", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message v1.Project
 */
export const Project = proto3.makeMessageType(
  "v1.Project",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "opt_title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "opt_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "opt_body", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "opt_readonly", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 6, name: "opt_protected", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 7, name: "opt_can_delete", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 8, name: "opt_can_upload", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 9, name: "opt_language", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "opt_color_mode", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message v1.Schoolroom
 */
export const Schoolroom = proto3.makeMessageType(
  "v1.Schoolroom",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "opt_vendor_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "opt_room_number", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "opt_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "opt_representative_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "opt_postal_number", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "opt_address1", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "opt_address2", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "opt_phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "opt_email", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "opt_note", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message v1.LoginRequest
 */
export const LoginRequest = proto3.makeMessageType(
  "v1.LoginRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.LoginResponse
 */
export const LoginResponse = proto3.makeMessageType(
  "v1.LoginResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.GreetRequest
 */
export const GreetRequest = proto3.makeMessageType(
  "v1.GreetRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.GreetResponse
 */
export const GreetResponse = proto3.makeMessageType(
  "v1.GreetResponse",
  () => [
    { no: 1, name: "greeting", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.HealthRequest
 */
export const HealthRequest = proto3.makeMessageType(
  "v1.HealthRequest",
  [],
);

/**
 * @generated from message v1.HealthResponse
 */
export const HealthResponse = proto3.makeMessageType(
  "v1.HealthResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.HomeRequest
 */
export const HomeRequest = proto3.makeMessageType(
  "v1.HomeRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.HomeResponse
 */
export const HomeResponse = proto3.makeMessageType(
  "v1.HomeResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.LogoutRequest
 */
export const LogoutRequest = proto3.makeMessageType(
  "v1.LogoutRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.LogoutResponse
 */
export const LogoutResponse = proto3.makeMessageType(
  "v1.LogoutResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
  ],
);

/**
 * @generated from message v1.UploadSb3Request
 */
export const UploadSb3Request = proto3.makeMessageType(
  "v1.UploadSb3Request",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "content", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * @generated from message v1.UploadSb3Response
 */
export const UploadSb3Response = proto3.makeMessageType(
  "v1.UploadSb3Response",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "projectId", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message v1.GetProjectsRequest
 */
export const GetProjectsRequest = proto3.makeMessageType(
  "v1.GetProjectsRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.GetProjectsResponse
 */
export const GetProjectsResponse = proto3.makeMessageType(
  "v1.GetProjectsResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "projects", kind: "message", T: Project, repeated: true },
  ],
);

/**
 * @generated from message v1.GetUsersRequest
 */
export const GetUsersRequest = proto3.makeMessageType(
  "v1.GetUsersRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.GetUsersResponse
 */
export const GetUsersResponse = proto3.makeMessageType(
  "v1.GetUsersResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "users", kind: "message", T: User, repeated: true },
  ],
);

/**
 * @generated from message v1.GetAllUserExRequest
 */
export const GetAllUserExRequest = proto3.makeMessageType(
  "v1.GetAllUserExRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.GetAllUserExResponse
 */
export const GetAllUserExResponse = proto3.makeMessageType(
  "v1.GetAllUserExResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "buf", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * @generated from message v1.GetAdminsRequest
 */
export const GetAdminsRequest = proto3.makeMessageType(
  "v1.GetAdminsRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.GetAdminsResponse
 */
export const GetAdminsResponse = proto3.makeMessageType(
  "v1.GetAdminsResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "admins", kind: "message", T: User, repeated: true },
  ],
);

/**
 * @generated from message v1.GetVendorsRequest
 */
export const GetVendorsRequest = proto3.makeMessageType(
  "v1.GetVendorsRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.GetVendorsResponse
 */
export const GetVendorsResponse = proto3.makeMessageType(
  "v1.GetVendorsResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "vendors", kind: "message", T: User, repeated: true },
  ],
);

/**
 * @generated from message v1.GetTeachersRequest
 */
export const GetTeachersRequest = proto3.makeMessageType(
  "v1.GetTeachersRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "opt_vendor_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message v1.GetTeachersResponse
 */
export const GetTeachersResponse = proto3.makeMessageType(
  "v1.GetTeachersResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "teachers", kind: "message", T: User, repeated: true },
  ],
);

/**
 * @generated from message v1.GetStudentsRequest
 */
export const GetStudentsRequest = proto3.makeMessageType(
  "v1.GetStudentsRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "opt_vendor_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "opt_schoolroom_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "downloadexcelfile", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * @generated from message v1.GetStudentsResponse
 */
export const GetStudentsResponse = proto3.makeMessageType(
  "v1.GetStudentsResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "students", kind: "message", T: User, repeated: true },
  ],
);

/**
 * @generated from message v1.GetStudentsExResponse
 */
export const GetStudentsExResponse = proto3.makeMessageType(
  "v1.GetStudentsExResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "buf", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * @generated from message v1.SaveStudentsExRequest
 */
export const SaveStudentsExRequest = proto3.makeMessageType(
  "v1.SaveStudentsExRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "vendor_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "data", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.SaveStudentsExResponse
 */
export const SaveStudentsExResponse = proto3.makeMessageType(
  "v1.SaveStudentsExResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
  ],
);

/**
 * @generated from message v1.SaveUserRequest
 */
export const SaveUserRequest = proto3.makeMessageType(
  "v1.SaveUserRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user", kind: "message", T: User },
    { no: 3, name: "new_user", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message v1.SaveUserResponse
 */
export const SaveUserResponse = proto3.makeMessageType(
  "v1.SaveUserResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
  ],
);

/**
 * @generated from message v1.UpdateUserImageRequest
 */
export const UpdateUserImageRequest = proto3.makeMessageType(
  "v1.UpdateUserImageRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "image_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.UpdateUserImageResponse
 */
export const UpdateUserImageResponse = proto3.makeMessageType(
  "v1.UpdateUserImageResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
  ],
);

/**
 * @generated from message v1.DeleteUserRequest
 */
export const DeleteUserRequest = proto3.makeMessageType(
  "v1.DeleteUserRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.DeleteUserResponse
 */
export const DeleteUserResponse = proto3.makeMessageType(
  "v1.DeleteUserResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
  ],
);

/**
 * @generated from message v1.DeleteAllUserRequest
 */
export const DeleteAllUserRequest = proto3.makeMessageType(
  "v1.DeleteAllUserRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "vendor_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.DeleteAllUserResponse
 */
export const DeleteAllUserResponse = proto3.makeMessageType(
  "v1.DeleteAllUserResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
  ],
);

/**
 * @generated from message v1.SaveSchoolroomRequest
 */
export const SaveSchoolroomRequest = proto3.makeMessageType(
  "v1.SaveSchoolroomRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "schoolroom", kind: "message", T: Schoolroom },
    { no: 3, name: "new_schoolroom", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message v1.SaveSchoolroomResponse
 */
export const SaveSchoolroomResponse = proto3.makeMessageType(
  "v1.SaveSchoolroomResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message v1.GetUserRequest
 */
export const GetUserRequest = proto3.makeMessageType(
  "v1.GetUserRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.GetUserResponse
 */
export const GetUserResponse = proto3.makeMessageType(
  "v1.GetUserResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "user", kind: "message", T: User },
    { no: 4, name: "opt_vendor_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "opt_schoolroom_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message v1.GetSchoolroomLastNumberRequest
 */
export const GetSchoolroomLastNumberRequest = proto3.makeMessageType(
  "v1.GetSchoolroomLastNumberRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "vendor_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.GetSchoolroomLastNumberResponse
 */
export const GetSchoolroomLastNumberResponse = proto3.makeMessageType(
  "v1.GetSchoolroomLastNumberResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "last_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "last_roomnumber", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.GetSchoolroomsRequest
 */
export const GetSchoolroomsRequest = proto3.makeMessageType(
  "v1.GetSchoolroomsRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "opt_vendor_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message v1.GetSchoolroomsResponse
 */
export const GetSchoolroomsResponse = proto3.makeMessageType(
  "v1.GetSchoolroomsResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "schoolrooms", kind: "message", T: Schoolroom, repeated: true },
  ],
);

/**
 * @generated from message v1.GetSchoolroomRequest
 */
export const GetSchoolroomRequest = proto3.makeMessageType(
  "v1.GetSchoolroomRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message v1.GetSchoolroomResponse
 */
export const GetSchoolroomResponse = proto3.makeMessageType(
  "v1.GetSchoolroomResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "schoolroom", kind: "message", T: Schoolroom },
  ],
);

/**
 * @generated from message v1.GetCoursewareFileListRequest
 */
export const GetCoursewareFileListRequest = proto3.makeMessageType(
  "v1.GetCoursewareFileListRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.GetCoursewareFileListResponse
 */
export const GetCoursewareFileListResponse = proto3.makeMessageType(
  "v1.GetCoursewareFileListResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "file_list", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.RegisterCoursewaresRequest
 */
export const RegisterCoursewaresRequest = proto3.makeMessageType(
  "v1.RegisterCoursewaresRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.RegisterCoursewaresResponse
 */
export const RegisterCoursewaresResponse = proto3.makeMessageType(
  "v1.RegisterCoursewaresResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.Courseware
 */
export const Courseware = proto3.makeMessageType(
  "v1.Courseware",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "project_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "document_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "movie_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "thumbnail_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "permission", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "medal", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message v1.GetCoursewaresRequest
 */
export const GetCoursewaresRequest = proto3.makeMessageType(
  "v1.GetCoursewaresRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.GetCoursewaresResponse
 */
export const GetCoursewaresResponse = proto3.makeMessageType(
  "v1.GetCoursewaresResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "coursewares", kind: "message", T: Courseware, repeated: true },
  ],
);

/**
 * @generated from message v1.Work
 */
export const Work = proto3.makeMessageType(
  "v1.Work",
  () => [
    { no: 1, name: "eid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "project_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "courseware_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "document_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "movie_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "thumbnail_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "permission", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "medal", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "open_at_rfc3339", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "statusset_rfc3339", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "updated_at_rfc3339", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "created_at_rfc3339", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.GetWorksRequest
 */
export const GetWorksRequest = proto3.makeMessageType(
  "v1.GetWorksRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.GetWorksResponse
 */
export const GetWorksResponse = proto3.makeMessageType(
  "v1.GetWorksResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "works", kind: "message", T: Work, repeated: true },
  ],
);

/**
 * @generated from message v1.GetCoursewareByProjectRequest
 */
export const GetCoursewareByProjectRequest = proto3.makeMessageType(
  "v1.GetCoursewareByProjectRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.GetCoursewareByProjectResponse
 */
export const GetCoursewareByProjectResponse = proto3.makeMessageType(
  "v1.GetCoursewareByProjectResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "courseware", kind: "message", T: Courseware },
  ],
);

/**
 * @generated from message v1.SaveWorkRequest
 */
export const SaveWorkRequest = proto3.makeMessageType(
  "v1.SaveWorkRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "work", kind: "message", T: Work },
  ],
);

/**
 * @generated from message v1.SaveWorkResponse
 */
export const SaveWorkResponse = proto3.makeMessageType(
  "v1.SaveWorkResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
  ],
);

/**
 * @generated from message v1.AddWorksRequest
 */
export const AddWorksRequest = proto3.makeMessageType(
  "v1.AddWorksRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "student_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "courseware_ids", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
  ],
);

/**
 * @generated from message v1.AddWorksResponse
 */
export const AddWorksResponse = proto3.makeMessageType(
  "v1.AddWorksResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
  ],
);

/**
 * @generated from message v1.DeleteWorkRequest
 */
export const DeleteWorkRequest = proto3.makeMessageType(
  "v1.DeleteWorkRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "work_eid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.DeleteWorkResponse
 */
export const DeleteWorkResponse = proto3.makeMessageType(
  "v1.DeleteWorkResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
  ],
);

/**
 * @generated from message v1.AddGroupWorksRequest
 */
export const AddGroupWorksRequest = proto3.makeMessageType(
  "v1.AddGroupWorksRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "vender_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "courseware_ids", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
  ],
);

/**
 * @generated from message v1.AddGroupWorksResponse
 */
export const AddGroupWorksResponse = proto3.makeMessageType(
  "v1.AddGroupWorksResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
  ],
);

/**
 * @generated from message v1.DeleteGroupWorkRequest
 */
export const DeleteGroupWorkRequest = proto3.makeMessageType(
  "v1.DeleteGroupWorkRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "vender_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.DeleteGroupWorkResponse
 */
export const DeleteGroupWorkResponse = proto3.makeMessageType(
  "v1.DeleteGroupWorkResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
  ],
);

/**
 * @generated from message v1.Directory
 */
export const Directory = proto3.makeMessageType(
  "v1.Directory",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "base", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "files", kind: "message", T: File, repeated: true },
    { no: 4, name: "directories", kind: "message", T: Directory, repeated: true },
  ],
);

/**
 * @generated from message v1.File
 */
export const File = proto3.makeMessageType(
  "v1.File",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "base", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "opt_courseware", kind: "message", T: Courseware, opt: true },
  ],
);

/**
 * @generated from message v1.GetCoursewareFileTreeRequest
 */
export const GetCoursewareFileTreeRequest = proto3.makeMessageType(
  "v1.GetCoursewareFileTreeRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.GetCoursewareFileTreeResponse
 */
export const GetCoursewareFileTreeResponse = proto3.makeMessageType(
  "v1.GetCoursewareFileTreeResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "root", kind: "message", T: Directory },
    { no: 4, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.GetCoursewareTreeRequest
 */
export const GetCoursewareTreeRequest = proto3.makeMessageType(
  "v1.GetCoursewareTreeRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.GetCoursewareTreeResponse
 */
export const GetCoursewareTreeResponse = proto3.makeMessageType(
  "v1.GetCoursewareTreeResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "root", kind: "message", T: Directory },
    { no: 4, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.GetLastIdRequest
 */
export const GetLastIdRequest = proto3.makeMessageType(
  "v1.GetLastIdRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "vendor_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.GetLastIdResponse
 */
export const GetLastIdResponse = proto3.makeMessageType(
  "v1.GetLastIdResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "last_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.IssueCodeRequest
 */
export const IssueCodeRequest = proto3.makeMessageType(
  "v1.IssueCodeRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "student_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "clear", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * @generated from message v1.IssueCodeResponse
 */
export const IssueCodeResponse = proto3.makeMessageType(
  "v1.IssueCodeResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "student_user", kind: "message", T: User },
  ],
);

/**
 * @generated from message v1.GetLogsRequest
 */
export const GetLogsRequest = proto3.makeMessageType(
  "v1.GetLogsRequest",
  () => [
    { no: 2, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "opt_since_rfc3339", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "opt_until_rfc3339", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "opt_timezone_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message v1.Log
 */
export const Log = proto3.makeMessageType(
  "v1.Log",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "created_at_rfc3339", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "user_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "user_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "user_status_readable", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "action", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "vendor_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "vendor_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.GetLogsResponse
 */
export const GetLogsResponse = proto3.makeMessageType(
  "v1.GetLogsResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "logs", kind: "message", T: Log, repeated: true },
  ],
);

/**
 * @generated from message v1.GetRegistrationLogsRequest
 */
export const GetRegistrationLogsRequest = proto3.makeMessageType(
  "v1.GetRegistrationLogsRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.RegistrationLog
 */
export const RegistrationLog = proto3.makeMessageType(
  "v1.RegistrationLog",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message v1.GetRegistrationLogsResponse
 */
export const GetRegistrationLogsResponse = proto3.makeMessageType(
  "v1.GetRegistrationLogsResponse",
  () => [
    { no: 1, name: "error", kind: "message", T: Error },
    { no: 2, name: "current_user", kind: "message", T: User },
    { no: 3, name: "logs", kind: "message", T: RegistrationLog, repeated: true },
  ],
);

